// actions
import { popupSteps } from '@fttb/common/constants';
import { setCtn } from "../../../../../store/callbackRequest/slice";
import { getTargetTariffType } from "../selectors/orderTariffCommon";
import { resetStepsData } from "../reducers/slice";
import { getCurrentFormStep } from "../selectors/modal";
import { resetAddressData, resetTariffData, resetUserData, setPopupVisibility } from "./common";
import { ymOrderAlternativeTariffView, ymOrderTariffAddressView, ymOrderTariffCalendarView, ymOrderTariffDetailsView } from "../../analytics";
export var resetOrderTariffData = function resetOrderTariffData() {
  return function (dispatch, getState) {
    var currentStep = getCurrentFormStep(getState());
    var _getTargetTariffType = getTargetTariffType(getState()),
      tariffType = _getTargetTariffType.tariffType;
    if (currentStep === popupSteps.addressRequestForm) {
      ymOrderTariffAddressView('address_close', tariffType);
    }
    if (currentStep === popupSteps.alternativeTariff) {
      ymOrderAlternativeTariffView('tariff_close');
    }
    if (currentStep === popupSteps.tariffDetailsForm) {
      ymOrderTariffDetailsView('bid_close');
    }
    if (currentStep === popupSteps.calendarForm) {
      ymOrderTariffCalendarView('visit_close');
    }
    dispatch(setPopupVisibility());
    dispatch(resetUserData());
    dispatch(resetStepsData());
    dispatch(resetTariffData());
    dispatch(resetAddressData());
    dispatch(setCtn(''));
  };
};